var modules_be025dea = {"container":"_1arjiz8","icon":"_1qwzro8","is-arrow-turned":"_b0v4eo"};
import "../../../assets/HEvJh3lZ.css";

export { modules_be025dea as default };
//# sourceMappingURL=Select.module.less.js.map
